import CVImageToAdd from '../../img/portrait.jpg';

export const CvPhoto = (): JSX.Element => (
  <img alt="portrait of me" src={CVImageToAdd} className=" my-8" />
);
